export default "__VITE_ASSET__D7eo4KK6__"